<template>
  <div class="config-page">
    <div class="bg-grid" aria-hidden="true"></div>

    <div class="config-shell">
      <!-- Header -->
      <header class="page-header fade-in">
        <div class="page-icon-box">
          <v-icon color="#F2F2ED" size="20">mdi-cog</v-icon>
        </div>
        <div>
          <h1 class="page-title">Configuración</h1>
          <p class="page-sub">Información general del gimnasio</p>
        </div>
      </header>

      <!-- Form -->
      <section class="fade-in delay-100">
        <div class="card-flat">
          <div class="card-flat-head">
            <span class="section-eyebrow">
              <span class="tick-mark"></span>
              Información del gimnasio
            </span>
          </div>
          <div class="card-flat-body">
            <form-configuracion
              :ajustes="datosAjustes"
              @registrar="onRegistrar"
              v-if="datosAjustes"
            />
          </div>
        </div>
      </section>
    </div>

    <!-- Loading overlay -->
    <v-overlay :value="cargando" opacity="0.9" color="#0E0E10">
      <div class="loading-inner">
        <div class="spinner"></div>
        <p class="loading-text">Guardando cambios…</p>
      </div>
    </v-overlay>

    <!-- Snackbar -->
    <v-snackbar
      v-model="mostrarMensaje"
      :timeout="3000"
      :color="mensaje.color"
      top
      right
    >
      <div class="flex items-center gap-md">
        <v-icon color="white">{{ mensajeIcon }}</v-icon>
        <span>{{ mensaje.texto }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon small @click="mostrarMensaje = false" v-bind="attrs">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FormConfiguracion from "./FormConfiguracion.vue";
import HttpService from "../../Servicios/HttpService";

export default {
  name: "ConfiguracionComponent",
  components: { FormConfiguracion },

  data: () => ({
    datosAjustes: null,
    cargando: false,
    mostrarMensaje: false,
    mensaje: {
      texto: "",
      color: ""
    }
  }),

  computed: {
    mensajeIcon() {
      switch (this.mensaje.color) {
        case "success":
          return "mdi-check-circle";
        case "error":
          return "mdi-alert-circle";
        case "warning":
          return "mdi-alert";
        default:
          return "mdi-information";
      }
    }
  },

  mounted() {
    this.obtenerAjustes();
  },

  methods: {
    onRegistrar(ajustes) {
      this.cargando = true;
      const imagenCambia = ajustes.logo.includes("data:image");
      if (!imagenCambia) {
        ajustes.logo = ajustes.logo.split("api/")[1];
      }
      ajustes.logoCambia = imagenCambia;
      console.log(ajustes);
      HttpService.registrar(
        {
          metodo: "registrar",
          ajustes: ajustes
        },
        "ajustes.php"
      ).then(resultado => {
        if (resultado) {
          this.mostrarMensaje = true;
          this.mensaje = {
            texto: "Datos actualizados correctamente",
            color: "success"
          };
          this.cargando = false;
          this.obtenerAjustes();
        }
      });
    },

    obtenerAjustes() {
      this.cargando = true;
      HttpService.obtenerConDatos({ metodo: "obtener" }, "ajustes.php").then(
        resultado => {
          this.datosAjustes = resultado;
          
          localStorage.setItem("nombreGimnasio", resultado.nombre);
          localStorage.setItem("logoGimnasio", resultado.logo);
          this.cargando = false;
        }
      );
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap");

/* ===== TOKENS ===== */
.config-page {
  --bg: #0e0e10;
  --card: #17171a;
  --card-border: #26262a;
  --text-primary: #f2f2ed;
  --text-secondary: #8c8c93;
  --text-tertiary: #5c5c62;
  --accent: #c8ff4d;
  --radius: 4px;

  --font-display: "Space Grotesk", sans-serif;
  --font-body: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: "JetBrains Mono", monospace;
}

.config-page {
  min-height: 100vh;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font-body);
  position: relative;
  padding: 40px;
}

.bg-grid {
  position: fixed;
  inset: 0;
  background-image: linear-gradient(
      rgba(242, 242, 237, 0.02) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(242, 242, 237, 0.02) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
}

.config-shell {
  position: relative;
  z-index: 1;
  max-width: 720px;
  margin: 0 auto;
}

/* ===== HEADER ===== */
.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px 26px;
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  margin-bottom: 24px;
}

.page-icon-box {
  width: 42px;
  height: 42px;
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid var(--card-border);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.page-title {
  font-family: var(--font-display);
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 2px;
}

.page-sub {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

/* ===== CARD ===== */
.card-flat {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
}

.card-flat-head {
  padding: 18px 24px;
  border-bottom: 1px solid var(--card-border);
}

.section-eyebrow {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.tick-mark {
  width: 12px;
  height: 1px;
  background: var(--accent);
}

.card-flat-body {
  padding: 24px;
}

/* ===== LOADING ===== */
.loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 24px;
  height: 24px;
  border: 2px solid var(--card-border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

.loading-text {
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--text-secondary);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== MOTION ===== */
.fade-in {
  animation: fadeIn 0.4s ease both;
}

.delay-100 {
  animation-delay: 0.05s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in,
  .spinner {
    animation: none;
  }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .config-page {
    padding: 20px;
  }

  .page-header {
    padding: 18px;
  }

  .card-flat-body {
    padding: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Configuracion/ConfiguracionComponent.vue